import * as Sentry from '@sentry/browser';

import type { User } from '../domain/user';

import { isProductionEnv } from './browser';

const createAppcuesService = () => {
  const isProduction = isProductionEnv();

  const init = (user: User) => {
    try {
      if (typeof window.Appcues !== 'undefined' && isProduction) {
        window.Appcues.reset();

        window.Appcues.identify(String(user.userId), {
          email: user.email,
          accountId: user.accountId,
          role: user.userRole,
        });
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: { service: 'AppcuesService', method: 'init' },
      });
    }
  };

  const pageChange = (pageName: string) => {
    try {
      if (isProduction) {
        window.location.hash = pageName;
        window.Appcues?.page();
      }
    } catch (error) {
      Sentry.captureException(error, {
        tags: { service: 'AppcuesService', method: 'pageChange' },
      });
    }
  };

  return {
    init,
    pageChange,
  };
};

export const AppcuesService = createAppcuesService();

export const loadAppcues = () => {
  const appcuesScript = document.createElement('script');
  appcuesScript.src = 'https://fast.appcues.com/131584.js';
  appcuesScript.async = true;
  document.head.appendChild(appcuesScript);
};
